export default "__VITE_ASSET__BEJyLWps__"